function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M55.33 18.89v32.45c0 3.19-2.66 6.12-6.12 6.12h-34.58c-3.19 0-6.12-2.66-6.12-6.12v-32.45",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.14 57.46v-17.56c0-3.19 2.66-6.12 6.12-6.12h5.32c3.19 0 6.12 2.66 6.12 6.12v17.29",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.92 4.79l29.26 17.55",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.92 4.79l-29.26 17.55",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.36a26a1e.svg";
export { ForwardRef as ReactComponent };